<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo lokacijo printanja:
    </h2>

    <LocationForm
      :barve="false"
      @save="save"
      @cancel="cancel"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LocationForm from '@/components/LocationForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    LocationForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('printerslocations', ['saveItem']),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyPrintersLocations'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyPrintersLocations' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
